// extracted by mini-css-extract-plugin
export default {"root":"ShareListingButton_root__H56oR","label":"ShareListingButton_label__RduW3"};